import React, { useState } from "react";
import Fetchtable from "../components/Fetchtable";
import { Tooltip, Button, Modal, Popconfirm, message, Select } from "antd";
import Createhr from "../components/Createhr";
import axios from "axios";
import { MdOutlineDeleteOutline } from "react-icons/md";
import useAuth from "../hooks/useAuth";

const URL = process.env.REACT_APP_API_URL;

const Admin = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedCandidate, setSelectedCandidate] = useState();
  const { token } = useAuth();
  const { Option } = Select;

  const handleStatusChange = (id, newStatus) => {
    console.log(`Status changed for ID ${id}: ${newStatus}`);

    // You can make an API call or update the state here
    axios.patch(`${URL}/api/updateCandidateData-HrStatusWise/${id}`, { hrStatus: newStatus },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then(response => {
        // console.log("Status updated successfully", response.data);
        message.success("Status updated successfully");
      }).catch(error => {
        // console.error("Error updating status", error);
        message.error("Failed to update status");
      });
  };


  const userColumns = [
    {
      name: "Name",
      selector: (row) => row.fullName,
      sortable: true,
      cell: (row) => (
        <span className="custom-cell" style={{ textTransform: "capitalize" }}>
          {row.fullName}
        </span>
      ),
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "300px",
    },
    {
      name: "Department",
      selector: (row) => row.department,
      sortable: true,
      width: "150px",
    },
    {
      name: "Location",
      cell: (row) => row.currentLocation,
      sortable: true,
      width: "150px",
    },
    {
      name: "Role",
      width: "120px",
      cell: (row) => (
        <div
          style={{
            backgroundColor: getRoleColor(row.role),
            color: "white",
            padding: "5px 10px",
            borderRadius: "5px",
            textAlign: "center",
          }}
        >
          {row.role}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        row.role === "HR" ? (
          <>
            <Select
              value={row.hrStatus === "Active"? "Active" : row.hrStatus === "Inactive"? 'Inactive' : "N/A"}
              style={{ width: 120 }}
              onChange={(value) => handleStatusChange(row._id, value)}
            >
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
            </Select>
            <Popconfirm
              title="Are you sure to delete this candidate?"
              onConfirm={() => handleDelete(row._id)}
              okText="Yes"
              cancelText="No"
            >
              <Button type="link" danger>
                <MdOutlineDeleteOutline size={20} />
              </Button>
            </Popconfirm>
          </>
        ) : (
          <Popconfirm
            title="Are you sure to delete this candidate?"
            onConfirm={() => handleDelete(row._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              <MdOutlineDeleteOutline size={20} />
            </Button>
          </Popconfirm>
        )
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const getRoleColor = (role) => {
    switch (role) {
      case "HR":
        return "#00B4d2";
      case "Panelist":
        return "#1a2763";
      case "HiringManager":
        return "#54ab6a";
      default:
        return "black";
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${URL}/api/candidate/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      message.success("Candidate deleted successfully");

      setRefreshKey((prevKey) => prevKey + 1);
    } catch (error) {
      console.error("Error deleting candidate:", error);
      message.error("Failed to delete candidate. Please try again later.");
    }
  };

  return (
    <div className="vh-page">
      <div>
        <Fetchtable
          url={`${URL}/api/hrs`}
          columns={userColumns}
          key={refreshKey}
          fileName="Users_Data"
          extraContent={
            <Tooltip title="Create HR/Panelist" color="cyan">
              <Button
                onClick={showModal}
                className="add-button"
                type="primary"
                style={{ marginTop: "1px" }}
              >
                Create User
              </Button>
            </Tooltip>
          }
        />
      </div>
      <Modal
        open={isModalVisible}
        onCancel={closeModal}
        footer={null}
        width={800}
        title={<h2>Create ATS User</h2>}
      >
        <Createhr closeModal={closeModal} />
      </Modal>
    </div>
  );
};

export default Admin;
